import axios from 'axios'
import HTTP from './http'

export default {
    list: () => axios.get(HTTP.GROUP_POLICY_PROVIDER_LIST),
    pairList: () => axios.get(HTTP.GROUP_POLICY_PROVIDER_PAIR_LIST),
    addProvider: payload => axios.post(HTTP.GROUP_POLICY_PROVIDER, payload),
    updateProvider: payload => axios.put(HTTP.GROUP_POLICY_PROVIDER, payload),
    deleteProvider: payload => axios.delete(HTTP.GROUP_POLICY_PROVIDER, { params: { id: payload } }),
    relatedPolicies: payload => axios.get(HTTP.GROUP_POLICY_PROVIDER_POLICIES, { params: payload }),
    updatePolicies: payload => axios.put(HTTP.GROUP_POLICY_PROVIDER_POLICIES, payload),
    detachPolicies: payload => axios.delete(HTTP.GROUP_POLICY_PROVIDER_POLICIES, { params: { id: payload } }),
    relatedUsers: payload => axios.get(HTTP.GROUP_POLICY_PROVIDER_USERS, { params: payload })
}
